import React from 'react';

const PracticalinformationRegistration = () => {
  // Données pour les statistiques
  const stats = [
    {
      id: 1,
      tittle: "Âge",
      title: "10–17 ans",
      delay: "delay-1"
    },
    {
      id: 2,
      tittle: "Durée",
      title: "Modules de 6–8 semaines",
      delay: "delay-2"
    },
    {
      id: 3,
      tittle: "Mode",
      title: "Hybride (en ligne + présentiel au FabLab)",
      delay: "delay-3"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-light-2 dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="flex justify-center text-center mb-12">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-dark-1 mb-4">
              Infos pratiques & Inscriptions
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center  rounded-xl">
              <div className="text-3xl md:text-4xl font-bold text-purple-1 mb-2">
                {stat.tittle}
              </div>
              <div className="text-gray-600 dark:text-gray-400">
                {stat.title}
              </div>
            </div>
          ))}
          <a href="https://app.gonextmaker.com/auth/signup">
            <div className="px-[55px] py-3 bg-red-4 border-2 border-red-4 text-button rounded-full font-medium
            text-white hover:bg-transparent hover:text-red-4 flex items-center justify-center transition-colors">
              S’Inscrire Maintenant
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PracticalinformationRegistration;